import { openModal } from '@ff-it/ui';

export const PLAN_MODAL_SCOPE = 'plan';

type ModalOptions = Omit<NonNullable<Parameters<typeof openModal>[1]>, 'scope'>;

// @FIXME: we should change the modal api to use scope from closest context layer
export function openPlanModal<T>(render: Parameters<typeof openModal<T>>[0], options?: ModalOptions): Promise<T> {
  return openModal<T>(render, { ...options, scope: PLAN_MODAL_SCOPE });
}
